
export const karnatakaBrainHealth = {
    topicId: "C12039",
    projectId: "6729b650e26e4745131d8d59",
};


export const idMap = {
    "6729b7cae26e4745131d8d5e": {
            name:"neurocheck",
            districtId:"6729b869e26e4745131d8d64",
            designationId:"672c7fcbe26e4745131d8e94",
            dateId:"672c7ff7e26e4745131d8e95",
    },
    "672dff13e26e4745131d8fed": {
            name:"kabhi screening questions",
            districtId:"6729b869e26e4745131d8d64",
            designationId:"6758e841701f499be1db2bca",
            dateId:"6755b86fb0268e1f7db00947",
    },
    "67345ba7e26e4745131d9277": {
            name:"kabhi patient details collection",
            districtId:"6729b869e26e4745131d8d64",
            designationId:"67346058e26e4745131d92c9",
            dateId:"6734602de26e4745131d92c8",
    },
    "672f1076e26e4745131d90ba": {
            name:"medical follow-up",
            districtId:"672f11d3e26e4745131d90cf",
            designationId:"672f1406e26e4745131d90d4",
            dateId:"6755b98ab0268e1f7db00948",
    },
    "672f0e53e26e4745131d90a6": {
            name:"kabhi comprehensive training details",
            districtId:"672f1bf0e26e4745131d90e5",
            designationId:"672f1c31e26e4745131d90e8",
            dateId:"6755ba44b0268e1f7db00949",
    },
    "672f0a66e26e4745131d9098": {
            name:"kabhi awareness activity details",
            districtId:"672f1f71e26e4745131d9106",
            designationId:"672f2185e26e4745131d9110",
            dateId:"672f1e3fe26e4745131d90fb",
    },
}

export const OPERATORS = {
    "equals": "Eq",
    "not_equals": "Neq",
    "greater": "Greater",
    "greater_or_equals": "GreaterEq",
    "less": "Less",
    "less_or_equals": "LessEq",
    "in": "In",
}

export const POS_NEG_FIELD_VALUE = "Risk stats for screened people"

export const CHART_TYPES = {
        BAR_CHART : {
                value: "barchart",
                label:"Bar Chart"
        },
        PIE_CHART : {
                value:"piechart",
                label:"Pie Chart"
        }
}

export const dateKeyMapping = {
        day: 'DateWise',
        month: 'MonthWise',
        year: 'YearWise'
    };